import {chatPublicApi} from '@online-offer/shared';
import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

import {buyingOnlineOfferApi} from './api/buyingOnlineOfferApi';
import {digitalCertificateApi} from './api/digitalCertificateApi';
import {onlineOfferApi} from './api/onlineOfferApi';

export const store = configureStore({
  reducer: {
    [buyingOnlineOfferApi.reducerPath]: buyingOnlineOfferApi.reducer,
    [digitalCertificateApi.reducerPath]: digitalCertificateApi.reducer,
    [onlineOfferApi.reducerPath]: onlineOfferApi.reducer,
    [chatPublicApi.reducerPath]: chatPublicApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      buyingOnlineOfferApi.middleware,
      digitalCertificateApi.middleware,
      onlineOfferApi.middleware,
      chatPublicApi.middleware
    ),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
